<div class="ag-header-group-cell-label">
    <div class="group-header-label">{{ params.displayName }}</div>
    <div class="group-expand-button"
        [ngClass]="expandState"
        (click)="expandToggle()">
        <i class="fa fa-chevron-down"></i>
    </div>
</div>
